import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Apple, Play, Globe, ArrowLeft } from "lucide-react";
import { useLead } from "@/context/LeadContext";

const APP_STORE = "https://apps.apple.com/";
const PLAY_STORE = "https://play.google.com/store";

export default function DownloadPage() {
  const [platform, setPlatform] = useState("desktop");
  const { openLead } = useLead();

  useEffect(() => {
    window.scrollTo(0, 0);
    const ua = navigator.userAgent || "";
    if (/iPhone|iPad|iPod/i.test(ua)) {
      setPlatform("ios");
      window.location.href = APP_STORE;
    } else if (/Android/i.test(ua)) {
      setPlatform("android");
      window.location.href = PLAY_STORE;
    } else {
      setPlatform("desktop");
    }
  }, []);

  return (
    <div className="min-h-screen bg-ink text-bone flex items-center justify-center px-5 py-20" data-testid="download-page">
      <div className="w-full max-w-lg text-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-bone/60 hover:text-coral transition-colors mb-12"
          data-testid="download-back"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Chateaux
        </Link>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-5xl md:text-6xl tracking-tight"
        >
          Get Chateaux
        </motion.h1>
        <p className="mt-5 text-bone/70">
          {platform === "desktop"
            ? "Choose how you'd like to start. On mobile you'll be sent straight to your app store."
            : "Redirecting you to the store…"}
        </p>

        <div className="mt-12 flex flex-col gap-3">
          <a
            href={APP_STORE}
            data-testid="download-ios"
            className="inline-flex items-center justify-center gap-3 bg-bone text-ink py-4 text-sm font-medium hover:bg-coral hover:text-bone transition-colors"
          >
            <Apple className="w-5 h-5" /> Download on the App Store
          </a>
          <a
            href={PLAY_STORE}
            data-testid="download-android"
            className="inline-flex items-center justify-center gap-3 bg-bone text-ink py-4 text-sm font-medium hover:bg-coral hover:text-bone transition-colors"
          >
            <Play className="w-5 h-5" /> Get it on Google Play
          </a>
          <button
            onClick={() => openLead({ source: "download-web" })}
            data-testid="download-web"
            className="inline-flex items-center justify-center gap-3 border border-bone/30 py-4 text-sm font-medium hover:bg-bone hover:text-ink transition-colors"
          >
            <Globe className="w-5 h-5" /> Use it in your browser
          </button>
        </div>
      </div>
    </div>
  );
}
